/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is a measure of the confidence of a base call in DNA sequencing, defined as Q = −10 × log10(P) where P is the probability the call is wrong.`)
};

const es_phred_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es una medida de la confianza de una llamada de base en la secuenciación de ADN, definida como Q = −10 × log10(P), donde P es la probabilidad de que la llamada sea incorrecta.`)
};

const de_phred_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist ein Maß für die Zuverlässigkeit eines Basenaufrufs bei der DNA-Sequenzierung, definiert als Q = −10 × log10(P), wobei P die Wahrscheinlichkeit ist, dass der Aufruf falsch ist.`)
};

const nl_phred_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is een maat voor de betrouwbaarheid van een basecall bij DNA-sequencing, gedefinieerd als Q = −10 × log10(P) waarbij P de kans is dat de call fout is.`)
};

const fr_phred_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est une mesure de la confiance d'un appel de base en séquençage d'ADN, défini par Q = −10 × log10(P) où P est la probabilité que l'appel soit incorrect.`)
};

const it_phred_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È una misura della fiducia di una chiamata di base nel sequenziamento del DNA, definita come Q = −10 × log10(P) dove P è la probabilità che la chiamata sia errata.`)
};

const pt_br2_phred_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É uma medida da confiança de uma chamada de base no sequenciamento de DNA, definida como Q = −10 × log10(P), onde P é a probabilidade de a chamada estar errada.`)
};

const pt_phred_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É uma medida da confiança de uma chamada de base em sequenciação de ADN, definida como Q = −10 × log10(P), sendo P a probabilidade de a chamada estar errada.`)
};

const ja_phred_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNAシーケンシングにおける塩基コールの信頼度の指標で、Q = −10 × log10(P)（Pはコールが誤っている確率）と定義されます。`)
};

const zh_phred_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它是衡量 DNA 测序中碱基判读可信度的指标，定义为 Q = −10 × log10(P)，其中 P 是判读出错的概率。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_faq_a1", locale)
	if (locale === "en") return en_phred_faq_a1(inputs)
	if (locale === "es") return es_phred_faq_a1(inputs)
	if (locale === "de") return de_phred_faq_a1(inputs)
	if (locale === "nl") return nl_phred_faq_a1(inputs)
	if (locale === "fr") return fr_phred_faq_a1(inputs)
	if (locale === "it") return it_phred_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_phred_faq_a1(inputs)
	if (locale === "pt") return pt_phred_faq_a1(inputs)
	if (locale === "ja") return ja_phred_faq_a1(inputs)
	return zh_phred_faq_a1(inputs)
};